import { useEffect, useRef } from 'react'
import type { ActionErrorPayload } from '~/utils/actionErrorPayload'
import { emitApiError } from '~/utils/apiErrorEvents'

/**
 * Emits a global API error toast when a Remix action returns formError / error.
 */
export function useActionErrorNotification(
  actionData?: ActionErrorPayload | null,
  _options?: { title?: string },
) {
  const lastMessageRef = useRef<string | null>(null)

  useEffect(() => {
    if (!actionData) return

    const message =
      (typeof actionData.formError === 'string' && actionData.formError.trim()) ||
      (typeof actionData.error === 'string' && actionData.error.trim()) ||
      ''

    if (!message || message === lastMessageRef.current) return

    lastMessageRef.current = message
    emitApiError(message)
  }, [actionData])
}
